// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1O3bI","bigColWidth":"Table_bigColWidth__2eNkg","biggerColWidth":"Table_biggerColWidth__3el6a","row":"Table_row__30jru","col":"Table_col__3LyKp"};